import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/ui';
import { ROUTES } from '@shared/config/routes';

export function QuickActions({ counts }: { counts: Record<string, number> | undefined }) {
  const { t } = useTranslation();
  const submitted = counts?.['catalog.ProductSubmitted'] ?? 0;
  const published = counts?.['catalog.ProductPublished'] ?? 0;
  const pendingProducts = Math.max(0, submitted - published);
  const kycPending = counts?.['iam.KycStatusChanged'] ?? 0;
  const hiddenRfqs = counts?.['rfq.BuyRequestHidden'] ?? 0;

  const items = [
    { to: ROUTES.catalogModeration, label: t('dashboard.quickActions.moderationQueue'), n: pendingProducts },
    { to: `${ROUTES.manufacturers}?kyc=PENDING`, label: t('dashboard.quickActions.kycPending'), n: kycPending },
    { to: `${ROUTES.buyRequests}?hidden=true`, label: t('dashboard.quickActions.hiddenRfqs'), n: hiddenRfqs },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('dashboard.quickActions.title')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="flex items-center justify-between rounded-md border px-3 py-2 hover:bg-accent"
          >
            <span className="text-sm">{item.label}</span>
            <span className="text-sm font-semibold tabular-nums">{item.n}</span>
          </Link>
        ))}
      </CardContent>
    </Card>
  );
}
